import {put,takeLatest,call} from 'redux-saga/effects'
import * as venueService from "../../../services/venueService"
import {
    CHANGE_VENUE_EMAIL,
    CHANGE_VENUE_EMAIL_SUCCESS,
    CHANGE_VENUE_EMAIL_ERROR
}
    from "../../actions/venue"

function* changeVenueEmailSaga(action) {
    try {
        const data = yield call(venueService.ChangeEmail,action.payload)
        yield put({
            type: CHANGE_VENUE_EMAIL_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: CHANGE_VENUE_EMAIL_ERROR,error: error.data
        })
    }
}

export function* changeVenueEmailSagaWatcher() {
    yield takeLatest(CHANGE_VENUE_EMAIL,changeVenueEmailSaga)
}